import { jsx as _jsx } from "react/jsx-runtime";
import EducationClassroom from "./EducationClassroom";
export default function EduHistory() {
    return (_jsx(EducationClassroom, { subject: "history", title: "History Classroom", description: "Explore people, events, timelines, government, civics, causes, and effects with Ava.", placeholder: "Ask a history question, such as: What caused the American Revolution?" }));
}
